document.addEventListener('DOMContentLoaded', function() {
  
  // Gallery Thumbnail Click
  const thumbnails = document.querySelectorAll('.greeji-gallery__thumb');
  const mainImage = document.querySelector('.greeji-gallery__main img');
  
  if(thumbnails && mainImage) {
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function() {
        thumbnails.forEach(t => t.classList.remove('is-active'));
        this.classList.add('is-active');
        const newUrl = this.getAttribute('data-image-url');
        if(newUrl) mainImage.src = newUrl;
      });
    });
  }

  // Quantity Buttons
  const qtyMinus = document.querySelector('.greeji-qty-btn.minus');
  const qtyPlus = document.querySelector('.greeji-qty-btn.plus');
  const qtyInput = document.querySelector('.greeji-qty-input');
  
  if(qtyMinus && qtyPlus && qtyInput) {
    qtyMinus.addEventListener('click', function() {
      let currentVal = parseInt(qtyInput.value);
      if(currentVal > 1) qtyInput.value = currentVal - 1;
    });
    qtyPlus.addEventListener('click', function() {
      let currentVal = parseInt(qtyInput.value);
      qtyInput.value = currentVal + 1;
    });
  }

  // Accordions
  const accordions = document.querySelectorAll('.greeji-accordion__toggle');
  if(accordions) {
    accordions.forEach(acc => {
      acc.addEventListener('click', function() {
        const parent = this.closest('.greeji-accordion');
        const isOpen = parent.classList.contains('is-open');
        document.querySelectorAll('.greeji-accordion').forEach(a => {
          a.classList.remove('is-open');
          a.querySelector('.greeji-accordion__toggle').setAttribute('aria-expanded', 'false');
          a.querySelector('.greeji-accordion__content').setAttribute('aria-hidden', 'true');
        });
        if(!isOpen) {
          parent.classList.add('is-open');
          this.setAttribute('aria-expanded', 'true');
          parent.querySelector('.greeji-accordion__content').setAttribute('aria-hidden', 'false');
        }
      });
    });
  }

  // Promo Add Both Button
  const promoBtn = document.getElementById('GreejiPromoAddBtn');
  if(promoBtn) {
    promoBtn.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Get main product ID and quantity
      const mainForm = document.querySelector('.greeji-pdp__form-wrapper form');
      if(!mainForm) return;
      const mainId = mainForm.querySelector('input[name="id"]').value;
      const mainQty = mainForm.querySelector('input[name="quantity"]').value;
      
      // Promo product ID would ideally come from the element data attribute.
      // E.g. <button data-promo-id="..."></button>
      const promoId = this.getAttribute('data-promo-id');
      
      if(!mainId || !promoId) return;
      
      const originalText = this.innerText;
      this.innerText = 'Adding...';
      this.disabled = true;

      // Add both items using Shopify Cart API
      let formData = {
        'items': [{
          'id': parseInt(mainId),
          'quantity': parseInt(mainQty)
        }, {
          'id': parseInt(promoId),
          'quantity': 1
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if(!response.ok) throw new Error('Error adding items to cart');
        return response.json();
      })
      .then(data => {
        this.innerText = 'Added!';
        // Dispatch event to open existing theme cart drawer
        document.dispatchEvent(new CustomEvent('product:added', { detail: { items: data.items } }));
        setTimeout(() => {
          this.innerText = originalText;
          this.disabled = false;
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        this.innerText = 'Error';
        setTimeout(() => {
          this.innerText = originalText;
          this.disabled = false;
        }, 2000);
      });
    });
  }
});
